
    import './styles.scoped.css';
    export default {
  "arrow": "awsui_arrow_xjuzf_nljtu_185",
  "arrow-outer": "awsui_arrow-outer_xjuzf_nljtu_189",
  "arrow-inner": "awsui_arrow-inner_xjuzf_nljtu_189",
  "refresh": "awsui_refresh_xjuzf_nljtu_219",
  "arrow-position-right-top": "awsui_arrow-position-right-top_xjuzf_nljtu_229",
  "arrow-position-right-bottom": "awsui_arrow-position-right-bottom_xjuzf_nljtu_229",
  "arrow-position-left-top": "awsui_arrow-position-left-top_xjuzf_nljtu_232",
  "arrow-position-left-bottom": "awsui_arrow-position-left-bottom_xjuzf_nljtu_232",
  "arrow-position-top-center": "awsui_arrow-position-top-center_xjuzf_nljtu_235",
  "arrow-position-top-right": "awsui_arrow-position-top-right_xjuzf_nljtu_235",
  "arrow-position-top-left": "awsui_arrow-position-top-left_xjuzf_nljtu_235",
  "arrow-position-top-responsive": "awsui_arrow-position-top-responsive_xjuzf_nljtu_235",
  "arrow-position-bottom-center": "awsui_arrow-position-bottom-center_xjuzf_nljtu_238",
  "arrow-position-bottom-right": "awsui_arrow-position-bottom-right_xjuzf_nljtu_238",
  "arrow-position-bottom-left": "awsui_arrow-position-bottom-left_xjuzf_nljtu_238",
  "arrow-position-bottom-responsive": "awsui_arrow-position-bottom-responsive_xjuzf_nljtu_238",
  "body": "awsui_body_xjuzf_nljtu_334",
  "body-overflow-visible": "awsui_body-overflow-visible_xjuzf_nljtu_373",
  "has-dismiss": "awsui_has-dismiss_xjuzf_nljtu_377",
  "dismiss": "awsui_dismiss_xjuzf_nljtu_382",
  "dismiss-control": "awsui_dismiss-control_xjuzf_nljtu_390",
  "header-row": "awsui_header-row_xjuzf_nljtu_394",
  "header": "awsui_header_xjuzf_nljtu_394",
  "content": "awsui_content_xjuzf_nljtu_420",
  "content-overflow-visible": "awsui_content-overflow-visible_xjuzf_nljtu_428",
  "container": "awsui_container_xjuzf_nljtu_524",
  "container-body": "awsui_container-body_xjuzf_nljtu_532",
  "container-body-variant-annotation": "awsui_container-body-variant-annotation_xjuzf_nljtu_575",
  "container-body-size-small": "awsui_container-body-size-small_xjuzf_nljtu_580",
  "fixed-width": "awsui_fixed-width_xjuzf_nljtu_583",
  "container-body-size-medium": "awsui_container-body-size-medium_xjuzf_nljtu_587",
  "container-body-size-large": "awsui_container-body-size-large_xjuzf_nljtu_594",
  "container-arrow": "awsui_container-arrow_xjuzf_nljtu_606",
  "container-arrow-position-right-top": "awsui_container-arrow-position-right-top_xjuzf_nljtu_610",
  "container-arrow-position-right-bottom": "awsui_container-arrow-position-right-bottom_xjuzf_nljtu_610",
  "container-arrow-position-left-top": "awsui_container-arrow-position-left-top_xjuzf_nljtu_622",
  "container-arrow-position-left-bottom": "awsui_container-arrow-position-left-bottom_xjuzf_nljtu_622",
  "container-arrow-position-top-center": "awsui_container-arrow-position-top-center_xjuzf_nljtu_634",
  "container-arrow-position-top-right": "awsui_container-arrow-position-top-right_xjuzf_nljtu_634",
  "container-arrow-position-top-left": "awsui_container-arrow-position-top-left_xjuzf_nljtu_634",
  "container-arrow-position-top-responsive": "awsui_container-arrow-position-top-responsive_xjuzf_nljtu_634",
  "container-arrow-position-bottom-center": "awsui_container-arrow-position-bottom-center_xjuzf_nljtu_650",
  "container-arrow-position-bottom-right": "awsui_container-arrow-position-bottom-right_xjuzf_nljtu_654",
  "container-arrow-position-bottom-left": "awsui_container-arrow-position-bottom-left_xjuzf_nljtu_658",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_xjuzf_nljtu_1",
  "root": "awsui_root_xjuzf_nljtu_798",
  "trigger": "awsui_trigger_xjuzf_nljtu_834",
  "trigger-type-text": "awsui_trigger-type-text_xjuzf_nljtu_841",
  "trigger-inner-text": "awsui_trigger-inner-text_xjuzf_nljtu_876",
  "popover-content": "awsui_popover-content_xjuzf_nljtu_880"
};
  